import { useState } from 'react';
import classNames from 'classnames';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import { Spinner } from '../../../../../components/Spinner';
import { COLLECTION_POLICY_BADGE } from '../../../../../constants/fundings';
import { useEnv } from '../../../../../context/env-context';
import { useAuth } from '../../../../../hooks/useAuth';
import { makeRequest } from '../../../../../utils/makeRequest';
import { toast } from 'react-toastify';

function NewFundingPopoverCollectionPolicyForm({
  fundingId,
  fundingCollectionPolicyCode,
  refreshFundingData,
}) {
  const { apiOriginFunding } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [isOpen, setIsOpen] = useState(false);
  const [spinner, setSpinner] = useState(false);

  const handleToggle = e => {
    e?.stopPropagation();
    setIsOpen(!isOpen);
  };

  const setCollectionPolicyCode = async policyCode => {
    setSpinner(true);
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    const config = {
      token,
      url: `${apiOriginFunding}/set_collection_policy`,
      method: 'POST',
      data: JSON.stringify({ fundingId, policyCode }),
    };

    try {
      await makeRequest(config);
      await refreshFundingData();

      toast.success('Collection policy code updated!');
    } catch (error) {
      toast.error(error.message);
    } finally {
      handleToggle();
      setSpinner(false);
    }
  };

  return (
    <OverlayTrigger
      trigger="click"
      placement="auto"
      show={isOpen}
      popperConfig={{ modifiers: [{ name: 'offset', options: { offset: [0, 4] } }] }}
      overlay={
        <Popover className="custom-popover">
          <Popover.Body className="bo-common-popover-form-menu">
            <Spinner visible={spinner} size={36}>
              <div className="d-flex flex-column gap-2">
                {Object.entries(COLLECTION_POLICY_BADGE).map(([key, value]) => (
                  <Button
                    key={key}
                    className="bo-common-base-button"
                    onClick={e => {
                      e.stopPropagation();
                      setCollectionPolicyCode(key);
                    }}
                  >
                    <Badge
                      className={classNames(
                        'bo-inline-badge',
                        'bo-common-inline-badge-hover',
                        'shadow-sm',
                        'bo-w-180',
                        value?.color,
                      )}
                    >
                      {value?.text}
                    </Badge>
                  </Button>
                ))}
              </div>
              <div className="d-flex justify-content-center mt-3">
                <Button className="bo-common-button" onClick={handleToggle}>
                  Cancel
                </Button>
              </div>
            </Spinner>
          </Popover.Body>
        </Popover>
      }
    >
      <Badge
        onClick={handleToggle}
        className={classNames(
          'ms-auto bo-common-inline-badge',
          COLLECTION_POLICY_BADGE[fundingCollectionPolicyCode]?.color,
        )}
      >
        {COLLECTION_POLICY_BADGE[fundingCollectionPolicyCode]?.text}
      </Badge>
    </OverlayTrigger>
  );
}

export default NewFundingPopoverCollectionPolicyForm;
